<template>
    <v-ons-page>
    <!--<v-ons-page-->
            <!--v-on:init="vOnsInit"-->
            <!--v-on:show="vOnsShow"-->
    <!--&gt;-->
        <v-ons-toolbar ref="ref_toolbar">
            <div class="left">
                <v-ons-back-button>戻る</v-ons-back-button>
            </div>
            <div class="center">
                <v-ons-input
                        id="searchWord"
                        placeholder="検索"
                        v-on:input="updateSearchWord"
                        v-bind:style="{width: '50vw'}"
                        modifier="material"
                ></v-ons-input>
            </div>
            <div class="right">
                <v-ons-toolbar-button
                        icon="fa-times"
                        @click="clear"
                ></v-ons-toolbar-button>
            </div>
        </v-ons-toolbar>

        <div class="content">

            <v-ons-page>

                <v-ons-list class="header" ref="ref_header">
                    <v-ons-list-item>
                        <v-ons-row>
                            <v-ons-col class="hp" v-on:click="sort('hp')">
                                <span v-bind:style="{fontWeight: isSortOrder('hp')}">HP</span>
                            </v-ons-col>
                            <v-ons-col class="pp" v-on:click="sort('pp')">
                                <span v-bind:style="{fontWeight: isSortOrder('pp')}">PP</span>
                            </v-ons-col>
                            <v-ons-col class="s_atk" v-on:click="sort('s_atk')">
                                <span v-bind:style="{fontWeight: isSortOrder('s_atk')}">打撃</span>
                            </v-ons-col>
                            <v-ons-col class="r_atk" v-on:click="sort('r_atk')">
                                <span v-bind:style="{fontWeight: isSortOrder('r_atk')}">射撃</span>
                            </v-ons-col>
                            <v-ons-col class="t_atk" v-on:click="sort('t_atk')">
                                <span v-bind:style="{fontWeight: isSortOrder('t_atk')}">法撃</span>
                            </v-ons-col>
                            <v-ons-col class="dex" v-on:click="sort('dex')">
                                <span v-bind:style="{fontWeight: isSortOrder('dex')}">技量</span>
                            </v-ons-col>
                            <v-ons-col class="s_def" v-on:click="sort('s_def')">
                                <span v-bind:style="{fontWeight: isSortOrder('s_def')}">打防</span>
                            </v-ons-col>
                            <v-ons-col class="r_def" v-on:click="sort('r_def')">
                                <span v-bind:style="{fontWeight: isSortOrder('r_def')}">射防</span>
                            </v-ons-col>
                            <v-ons-col class="t_def" v-on:click="sort('t_def')">
                                <span v-bind:style="{fontWeight: isSortOrder('t_def')}">法防</span>
                            </v-ons-col>
                        </v-ons-row>
                    </v-ons-list-item>
                </v-ons-list>

                <div class="content" v-bind:style="{top: headerHeight + 'px'}">
                    <v-ons-list v-if="this.$store.state.userAbilities[this.$store.state.targetIndex]">
                        <v-ons-list-item
                                tappable
                                modifier="longdivider"
                                v-on:click="setAbility(null)"
                                v-show="true"
                        >
                            選択中（{{this.$store.state.userAbilities[this.$store.state.targetIndex].name}}）を解除
                        </v-ons-list-item>
                    </v-ons-list>

                    <v-ons-list>
                        <v-ons-lazy-repeat
                                v-bind:render-item="renderItem"
                                v-bind:length="itemCount"
                        ></v-ons-lazy-repeat>
                    </v-ons-list>
                </div>


            </v-ons-page>
        </div>

    </v-ons-page>
</template>

<script>
    // グループ内の特殊能力を複数設置可能なグループ
    const DUPLICATE_POSSIBLE_GROUP_IDS = [14, 51, 53, 54];

    import Vue from 'vue';
    import Vuex from 'vuex';
    import store from '../store';
    import Linq from 'linq';
    import abilityListItem from './AbilityListItem';

    Vue.use(Vuex);

    export default {
        name: "AbilityList.vue",
        created() {
            this.$eventHub.$on('on-select-list-item', this.setAbility);
            this.$ga.page('/AbilityInput')
        },
        beforeMount() {
            this.sort(null);
            Linq.from(this.abilities)
                .forEach(ability => {
                    ability.visible = true;
                    ability.matched = true;
                });

            let excludeGroupIds = [];
            let excludeNames = [];
            for (let i = 0; i < 8; i++) {
                if (i === this.$store.state.targetIndex) continue;
                let userAbility = this.$store.state.userAbilities[i];
                if (!userAbility) continue;
                if (DUPLICATE_POSSIBLE_GROUP_IDS.indexOf(userAbility.group_id) >= 0) {
                    excludeNames.push(userAbility.name);
                }
                else {
                    excludeGroupIds.push(userAbility.group_id);
                }
            }
            if (excludeGroupIds.length) {
                Linq.from(this.abilities)
                    .where(ability => (excludeGroupIds.includes(ability.group_id)))
                    .forEach(ability => {
                        ability.visible = false;
                        ability.matched = false;
                    });
            }
            if (excludeNames.length) {
                Linq.from(this.abilities)
                    .where(ability => (
                        Linq.from(excludeNames)
                            .select(name => name.replace(/[Ⅰ-Ⅸ]/g, ''))
                            .toArray()
                            .includes(ability.name.replace(/[Ⅰ-Ⅸ]/g, ''))
                    ))
                    .forEach(ability => {
                        ability.visible = false;
                        ability.matched = false;
                    });
            }
            this.itemCount = Linq.from(this.abilities)
                .count(ability => (ability.visible && ability.matched));
        },
        mounted() {
            // console.log('mounted');
            // console.log(this.$refs.ref_header ? this.$refs.ref_header.$el.clientHeight : null);
            // this.$nextTick(function () {
            //     console.log('mounted next-tick');
            //     console.log(this.$refs.ref_header ? this.$refs.ref_header.$el.clientHeight : null);
            this.headerHeight = this.$refs.ref_header ? this.$refs.ref_header.$el.clientHeight : null;
            // });
        },
        beforeDestroy() {
            this.$eventHub.$off('on-select-list-item');
        },

        methods: {
            vOnsInit() {
                console.log('abilityList v-ons-init');
                // console.log(this.$refs.ref_header ? this.$refs.ref_header.$el.clientHeight : null);
            },
            vOnsShow() {
                console.log('abilityList v-ons-show');
                // console.log(this.$refs.ref_header ? this.$refs.ref_header.$el.clientHeight : null);
            },
            setAbility(abilityId) {
                // 選択された特殊能力をセット
                let payload = {
                    index: this.$store.state.targetIndex,
                    id: abilityId
                };
                this.$store.commit('setUserAbility', payload);
                this.$db.working.put({
                    id: 1,
                    abilities: JSON.stringify(this.$store.state.userAbilities)
                });
                // 戻る
                this.$emit('pop-page');
            },
            updateSearchWord() {
                // 検索文字列の正規化（記号除去、ひらがなはカタカナへ、アラビア数字はローマ数字へ
                let searchWord = document.getElementById("searchWord").value
                    .replace(/[・：:\s]/g, '')
                    .replace(/[ぁ-ん]/g, (s) => String.fromCharCode(s.charCodeAt(0) + 0x60))
                    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
                    .replace(/[Ⅰ]/g, '1')
                    .replace(/[Ⅱ]/g, '2')
                    .replace(/[Ⅲ]/g, '3')
                    .replace(/[Ⅳ]/g, '4')
                    .replace(/[Ⅴ]/g, '5')
                    .replace(/[Ⅵ]/g, '6')
                    .replace(/[Ⅶ]/g, '7')
                    .replace(/[Ⅷ]/g, '8')
                    .replace(/[Ⅸ]/g, '9')
                    .toLowerCase()

                let order = this.sortOrder;
                this.sortOrder = null;
                this.sort(order);

                if (searchWord.length) {
                    let regexp = RegExp('^(?=.*' + searchWord + ').*$');
                    Linq.from(this.abilities)
                        .where(ability => (ability.visible))
                        .forEach(ability => {
                            ability.matched = regexp.test(ability.search_name);
                        });
                }
                else {
                    Linq.from(this.abilities)
                        .where(ability => (ability.visible))
                        .forEach(ability => {
                            ability.matched = true;
                        });
                }

                this.itemCount = Linq.from(this.abilities)
                    .count(ability => (ability.visible && ability.matched));

                // this.$emit('refresh');
            },
            sort(order) {
                if (order === null || order === this.sortOrder) {
                    this.abilities.sort((x, y) => {
                        return x.group_id - y.group_id || x.order - y.order;
                    });
                    this.sortOrder = null;
                }
                else {
                    this.abilities.sort((x, y) => {
                        return y[order] - x[order] || x.group_id - y.group_id || x.order - y.order;
                    });
                    this.sortOrder = order;
                }
                this.$emit('refresh');
            },
            isSortOrder(order) {
                return (order === this.sortOrder) ? 'bold' : 'normal';
            },
            clear() {
                document.getElementById("searchWord").value = '';
                this.updateSearchWord();
            }
        },
        computed: {},
        data() {
            return {
                abilities: this.$store.state.abilities,
                headerHeight: 0,
                itemCount: 0,
                sortOrder: null,
                renderItem: i => {
                    let _abilities = this.abilities;
                    return new Vue({
                        store: store,
                        components: {
                            abilityListItem
                        },
                        // template: '<ability-list-item v-bind:key="ability.id" v-bind:ability="ability"></ability-list-item>',
                        template: '<ability-list-item v-bind:ability="ability"></ability-list-item>',
                        data() {
                            return {
                                ability: Linq.from(_abilities)
                                    .where(x => (x.visible && x.matched))
                                    .elementAtOrDefault(i, _abilities[0])
                            }
                        }
                    })
                }
            }
        }
    }
</script>

<style scoped>
    div.content div.content {
        background-color: whitesmoke;
    }

    .header {
        font-size: small;
        text-align: center;
        position: relative;
    }

    .hp, .pp {

    }

    .s_atk, .s_def {
        background-color: #FEE;
    }

    .r_atk, .r_def {
        background-color: #EEF;
    }

    .t_atk, .t_def {
        background-color: #FFE;
    }

    .dex {
        background-color: #EFE;
    }
</style>
